import { render, staticRenderFns } from "./EventLogs.vue?vue&type=template&id=5fff6eb2&scoped=true&"
import script from "./EventLogs.vue?vue&type=script&lang=ts&"
export * from "./EventLogs.vue?vue&type=script&lang=ts&"
import style0 from "./EventLogs.vue?vue&type=style&index=0&id=5fff6eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff6eb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer,VSubheader})
